import { icon } from "@fortawesome/fontawesome-svg-core";
import { faServicestack } from "@fortawesome/free-brands-svg-icons";
import { faCode, faDiagramProject, faHome, faInfoCircle, faMobileAlt, faPalette, faShieldAlt, faUsers } from "@fortawesome/free-solid-svg-icons";

export const servicesRoutes = [
    {
        name: "Web Development",
        pathName: "/web-development",
        icon: faCode
    },
    {
        name: "Mobile Development",
        pathName: "/mobile-development",
        icon: faMobileAlt
    },
    {
        name: "Graphic Design",
        pathName: "/graphics-design",
        icon: faPalette
    },
    {
        name: "Cyber Security",
        pathName: "/cyber-security",
        icon: faShieldAlt
    }
]

export const routeList = [
    {
        uri: "/",
        pathName: "Home",
        icon: faHome
    },
    {
        uri: "/services",
        pathName: 'Services',
        icon: faServicestack,
        ismenu: true,
        submenu: servicesRoutes
    },
    {
        uri: "/personnel",
        pathName: "Personnel",
        icon: faUsers
    }
]

